<section class="title-info" id="header">
  <ng-container *ngIf="!isMobileDeviceSize;else mobileHeader">
    <div class="title-box">
      <div class="title-img"><img (click)="toggleOpened()" src="assets/img/USAN-logo.png" /></div>
      <div class="title-text">United States Adopted Names Application Portal</div>
      <div class="title-account">

        <button mat-button [matMenuTriggerFor]="menu" class="my-account-btn">
          My Account
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item><a href="{{ accountManagementCenterUrl }}">{{ displayName }}</a></button>
          <button mat-menu-item *ngIf="canUserSwitchRoles" (click)="switchRoles()">Switch Roles</button>
          <button mat-menu-item><a [routerLink]="" (click)="logOut()">Sign Out</a></button>
        </mat-menu>
      </div>
    </div>
  </ng-container>
  <ng-template #mobileHeader>
    <div class="title-box">
      <div class="title-img-mobile"><img src="assets/img/USAN-logo.png" /></div>
      <div class="title-text-mobile">USAN</div>
      <div class="title-account-mobile">
        <button mat-button [matMenuTriggerFor]="menu" class="my-account-btn">
          <span class="material-symbols-outlined">
            <mat-icon>account_circle</mat-icon>
          </span>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item><a href="{{ accountManagementCenterUrl }}">{{ displayName }}</a></button>
          <button mat-menu-item><a [routerLink]="" (click)="logOut()">Sign Out</a></button>
        </mat-menu>
      </div>
    </div>
  </ng-template>
</section>